import React from 'react';
import { getChipTone } from './intelligenceTheme';

export default function SignalChip({ label, tone, active = false, onClick, style = {}, title, role = 'status' }) {
  const colors = getChipTone(tone || label);
  const clickable = typeof onClick === 'function';
  const Element = clickable ? 'button' : 'span';

  return (
    <Element
      type={clickable ? 'button' : undefined}
      role={role}
      title={title}
      onClick={onClick}
      style={{
        appearance: 'none',
        border: `1px solid ${active ? 'rgba(77, 121, 255, 0.6)' : colors.borderColor}`,
        background: active ? 'rgba(77, 121, 255, 0.18)' : colors.background,
        color: colors.color,
        borderRadius: 999,
        padding: '6px 10px',
        fontSize: 11,
        lineHeight: 1,
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        cursor: clickable ? 'pointer' : 'default',
        whiteSpace: 'nowrap',
        boxShadow: active ? '0 0 0 1px rgba(77, 121, 255, 0.2)' : 'none',
        ...style,
      }}
    >
      {label}
    </Element>
  );
}
